import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import SneakerIcon from '../sneakerIcon';

const NavBar = () => (
  <AppBar position="sticky">
    <Toolbar sx={{ justifyContent: 'space-between' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <SneakerIcon sx={{ mr: 1 }} />
        <Typography
          component={Link}
          to="/"
          sx={{
            typography: { sm: 'h6', xs: 'body1' },
            color: 'inherit',
            textDecoration: 'none',
          }}
          noWrap
        >
          SpeedBoostShoes.com
        </Typography>
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 0.5 }}>
        <Button color="inherit" component={Link} to="/" size="small">
          Calculator
        </Button>
        <Button color="inherit" component={Link} to="/best-marathon-racing-shoes-2025" size="small">
          Shoe Reviews
        </Button>
        <Button color="inherit" component={Link} to="/how-much-faster-do-super-shoes-make-you" size="small">
          The Science
        </Button>
      </Box>
    </Toolbar>
  </AppBar>
);

export default NavBar;
